import { render } from "./TeamsView.vue?vue&type=template&id=0ad9a318&scoped=true"
import script from "./TeamsView.vue?vue&type=script&lang=js"
export * from "./TeamsView.vue?vue&type=script&lang=js"

import "./TeamsView.vue?vue&type=style&index=0&id=0ad9a318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad9a318"]])

export default __exports__